// context.js
import { createContext, useContext, useState, useEffect } from 'react';
import store from 'store';
import { useDispatch } from 'react-redux';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [auth, setAuth] = useState(() => {
    // Initialize from local storage if available
    const storedAuth = store.get('auth');
    return storedAuth || null;
  });

  const [isAuthorized, setIsAuthorized] = useState(() => {
    const token = store.get('AccessToken');
    return !!token;
  });

  const [loading, setLoading] = useState(false);

  // Update local storage when user changes
  useEffect(() => {
    if (auth) {
      store.set('auth', auth);
    } else {
      store.remove('auth');
    }
  }, [auth]);

  const login = (authData, token) => {
    setAuth(authData);
    setIsAuthorized(true);
    store.set('AccessToken', token);
  };

  const logout = () => {
    setAuth(null);
    setIsAuthorized(false);
    store.remove('AccessToken');
    store.remove('auth');

    dispatch({
      type: 'auth/LOGOUT',
    })
  };

  const updateAuth = (updates) => {
    setAuth(prev => ({
      ...prev,
      ...updates
    }));
  };

  return (
    <AuthContext.Provider 
      value={{ 
        auth,
        setAuth,
        isAuthorized,
        loading,
        setLoading,
        // login,
        logout,
        updateAuth
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within a AuthProvider');
  }
  return context;
};

export default AuthContext;
